export const GA_EVENT_CATEGORIES = {
    registration: "Registration",
    banking: "Banking",
    gameLaunch: "Game Launch",
    spinTheWheel: "Spin the Wheel",
};
